import BaseService from "./BaseService";

class LearningPathwayService {
  static async list(data) {
    const params = (data && BaseService.cleanQueryParams(data)) || {};
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/learning-pathways?${queryParams}`);
  }

  static async create(data) {
    return await BaseService.callAPI(`/learning-pathways`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/learning-pathways/${id}`);
  }

  static async update({ id, payload }) {
    return await BaseService.callAPI(
      `/learning-pathways/${id}`,
      "POST",
      payload
    );
  }

  static async assignments({ id }) {
    return await BaseService.callAPI(`/learning-pathways/${id}/assignments`);
  }

  static async createAssignment({ id, payload }) {
    return await BaseService.callAPI(
      `/learning-pathways/${id}/assignments`,
      "POST",
      payload
    );
  }

  static async dropDown() {
    return await BaseService.callAPI(`/learning-pathways/dropdown`);
  }

  static async deleteAssignment({ id }) {
    return await BaseService.callAPI(
      `/learning-pathways/assignment/${id}`,
      "DELETE"
    );
  }
}

export default LearningPathwayService;
